import {Grid} from '@material-ui/core';
import {SwitchCustom, TextBox} from '../../../Core/UI';
import React from 'react';
import {Parameter} from '../../../Core/mobx/ParameterStore/ParameterStore';
import {observer} from 'mobx-react-lite';
import {CategoryCard} from '../CategoryCard';
import {Approval} from '../../../Core/mobx/ParameterStore/Approval';
import {SelectInputElement} from '../../PreQualification/Components/SelectInputElement';
import {DatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {fieldOptions} from '../../../Core/mobx/ParameterStore/ApprovalXref';

type TobaccoInfoProps = {
    valueChanged: (p?: Parameter, value?: any) => void;
    parameters: Approval;
    setCategory: (entry: string) => void;
    index: number;
};

const TobaccoInfo = observer(({valueChanged, parameters, setCategory, index}: TobaccoInfoProps) => {
    const required = (value?: string) => (
        <span>
            {value && value} <span style={{color: 'red'}}>*</span>
        </span>
    );

    return (
        <CategoryCard title={'Tobacco & Marijuana'} setCategory={setCategory} index={index}>
            <Grid item xs={4}>
                <SwitchCustom
                    param={{
                        name: 'TobaccoRating',
                        label: 'Tobacco Rating',
                        ...parameters.TobaccoRating,
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={4}>
                <SwitchCustom
                    param={{
                        name: 'MarijuanaRating',
                        label: 'Marijuana Rating',
                        ...parameters.MarijuanaRating,
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={4}>
                <SwitchCustom
                    param={{
                        name: 'OtherRating',
                        label: 'Other Rating',
                        ...parameters.OtherRating,
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                />
            </Grid>
            {parameters.TobaccoRating.value && (
                <>
                    <Grid item xs={4}>
                        <SelectInputElement
                            param={{
                                label: 'Tobacco: Product Used',
                                name: 'tobaccoProducts',
                                options: fieldOptions.tobaccoProducts.options,
                                ...parameters.tobaccoProducts,
                            }}
                            required={required('')}
                            valueChanged={valueChanged}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <SelectInputElement
                            param={{
                                label: 'Tobacco: Frequency Of Usage',
                                name: 'tobaccoFrequency',
                                options: fieldOptions.tobaccoFrequency.options,
                                ...parameters.tobaccoFrequency,
                            }}
                            required={required('')}
                            valueChanged={valueChanged}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DatePicker
                                inputVariant="outlined"
                                variant="inline"
                                openTo="year"
                                views={['year', 'month']}
                                label={required('Tobacco: Last Usage')}
                                style={{width: '100%', marginTop: 8}}
                                value={parameters.tobaccoLastUse?.value || null}
                                onChange={(date) => valueChanged(parameters.tobaccoLastUse, date)}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                </>
            )}
            {parameters.MarijuanaRating.value && (
                <>
                    <Grid item xs={4}>
                        <SelectInputElement
                            param={{
                                label: 'Marijuana: Product Used',
                                name: 'marijuanaProducts',
                                options: fieldOptions.marijuanaProducts.options,
                                ...parameters.marijuanaProducts,
                            }}
                            required={required('')}
                            valueChanged={valueChanged}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <SelectInputElement
                            param={{
                                label: 'Marijuana: Frequency Of Usage',
                                name: 'marijuanaFrequency',
                                options: fieldOptions.marijuanaFrequency.options,
                                ...parameters.marijuanaFrequency,
                            }}
                            required={required('')}
                            valueChanged={valueChanged}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DatePicker
                                inputVariant="outlined"
                                variant="inline"
                                openTo="year"
                                views={['year', 'month']}
                                label={required('Marijuana: Last Usage')}
                                style={{width: '100%', marginTop: 8}}
                                value={parameters.marijuanaLastUse?.value || null}
                                onChange={(date) => valueChanged(parameters.marijuanaLastUse, date)}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                </>
            )}
            {parameters.OtherRating.value && (
                <>
                    <Grid item xs={4}>
                        <TextBox
                            id={'otherSubstance'}
                            label={required('Other: Substance Used')}
                            value={parameters.otherSubstance?.value}
                            onChange={(value) => valueChanged(parameters.otherSubstance, value)}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <SelectInputElement
                            param={{
                                label: 'Other: Product Used',
                                name: 'otherProducts',
                                options: fieldOptions.otherProducts.options,
                                ...parameters.otherProducts,
                            }}
                            required={required('')}
                            valueChanged={valueChanged}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <SelectInputElement
                            param={{
                                label: 'Other: Frequency Of Usage',
                                name: 'otherFrequency',
                                options: fieldOptions.otherFrequency.options,
                                ...parameters.otherFrequency,
                            }}
                            required={required('')}
                            valueChanged={valueChanged}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DatePicker
                                inputVariant="outlined"
                                variant="inline"
                                openTo="year"
                                views={['year', 'month']}
                                label={required('Other: Last Usage')}
                                style={{width: '100%', marginTop: 8}}
                                value={parameters.otherLastUse?.value || null}
                                onChange={(date) => valueChanged(parameters.otherLastUse, date)}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                </>
            )}
        </CategoryCard>
    );
});

export default TobaccoInfo;
